import { useState } from "react";
import Error from "../../Layouts/Error";
import InnerHeader from "../../Layouts/InnerHeader";
import Loading from "../../Layouts/Loading";
import { InvoicePay, Invoices, useGetAllInvoicesQuery, usePayOnlineInvoiceMutation } from "../../Redux/Apis/invoiceApi";
import { fa_currency, fa_dateـetime, fa_number } from "../../utils/Persian";
import { Link, useSearchParams } from "react-router-dom";

export default function Invoice() {
    const [payOnline, {isLoading: isPayLoading}] = usePayOnlineInvoiceMutation()
    const [errorMsg, setErrorMsg] = useState<any>(false)
    const [link,setLink] = useState<InvoicePay>()
    const [searchParams] = useSearchParams();

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetAllInvoicesQuery()
    
    const handlePay = async (id:number) => {
        try {
            const link = await payOnline(id).unwrap()
            if (link.url) {
                setLink(link)
                setErrorMsg(false)
                setTimeout(() => { 
                    window.location = link.url;
                }, 3000)
            }
            else {
                setErrorMsg("پرداخت با مشکل مواجع شد.")
            }
            
        } catch (err:any){
            console.log(err);
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }
    
    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess){
        return(
        <div className="container-lg">
            <InnerHeader name="صورتحساب ها" root='/'/>
            {errorMsg && <div className="alert alert-danger" role="alert">
                {errorMsg}
            </div>}
            {searchParams.get("status") === '0' && <div className="alert alert-danger" role="alert">
                پرداخت با مشکل مواجه شد لطفا مجددا تلاش نمایید.
            </div>}
            {searchParams.get("status") === '1' && <div className="alert alert-success" role="alert">
                صورتحساب شما با موفقیت پرداخت شد.
            </div>}
            <div className="row">
                <table className="table align-middle">
                    <thead>
                        <tr>
                        <th scope="col">#</th>
                        <th scope="col">مبلغ(تومان)</th>
                        <th scope="col">تاریخ</th>
                        <th scope="col">توضیحات</th>
                        <th scope="col">وضعیت</th>
                        <th scope="col">اقدامات</th>
                        </tr>
                    </thead>
                    <tbody>
                    {data && data.map((value:Invoices,index:number) => 
                        <tr key={index}>
                            <th scope="row">{fa_number(index + 1)}</th>
                            <td>{fa_currency(+value.price)}</td>
                            <td>{fa_dateـetime(value.create_date)}</td>
                            <td>{value.note && value.note.length > 50 ? value.note.slice(0,50).concat("...") : value.note}</td>
                            <td>
                                {value.status === "PAY" ? 
                                <div className="text-success">پرداخت شده</div> :
                                <div className="text-danger">پرداخت نشده</div>
                                }
                            </td>
                            <td>
                                <Link to={`/invoice/${value.id}`} type="button" className="btn btn-primary me-1 mb-1">
                                    مشاهده
                                </Link>
                                {value.status === "NOT_PAY" && !link && <button disabled={isPayLoading} onClick={() => handlePay(value.id)} type="button" className="btn btn-success me-1 mb-1">
                                    پرداخت آنلاین
                                </button>}
                                {link && value.status === "NOT_PAY" && <button onClick={() => window.location = link.url} type="button" className="btn btn-primary me-1 mb-1">
                                    <span className="spinner-grow spinner-grow-sm me-1" role="status" aria-hidden="true"></span>
                                    هدایت به درگاه...
                                </button>}
                            </td>
                        </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )}

    else return <></>
}